export class ZConfig 
{
    static KontrollListenExportPage = true
    static RechnungsDatenExportPage = true

    static IgnoreIbanAspPrintError = true

    static KontoErrorBackground = 'tomato'

}